export const applicationViewModes = {
    APPLICATION_VIEW_ALBUMS: 'APPLICATION_VIEW_ALBUMS',
    APPLICATION_VIEW_ALBUM_ITEMS: 'APPLICATION_VIEW_ALBUM_ITEMS'
};


// WEBPACK FOOTER //
// ./src/settings/actions/application-view-modes.js